export enum LanguageType {
    english = 0,
    chinese = 1
}
